let accounting = require("accounting");

let accountingSettings = {
  currency: {
    symbol: "$" // default currency symbol is '$'
    , format: "%s%v" // controls output: %s = symbol, %v = value/number (can be object: see below)
    , decimal: "." // decimal point separator
    , thousand: "," // thousands separator
    , precision: 2 // decimal places
  }
  , number: {
    precision: 0 // default precision on numbers is 0
    , thousand: ","
    , decimal: "."
  }
};

export const getAccounting = function (settings) {
  accounting.settings = accountingSettings;
  if (settings) accounting.settings = settings;

  return accounting;
};

export const setSelectsInactiveDataMultipleComma = function (val, completeList) {
  if (val && val != "") {
    const responseList = val.split(",");
    if (responseList && responseList.length > 0) {
      return completeList.filter((value) => {
        if (value.status) return value;
        const res = responseList.filter((value1) => value1 == value.code);
        return res.length > 0 ? res : null;
      });
    }
  }
  return completeList.filter((value) => value.status);
};

export const setSelectsInactiveDataMultipleJson = function (val, completeList) {
  if (val && val != "") {
    const responseList = JSON.parse(val);
    if (responseList && responseList.length > 0) {
      return completeList.filter((value) => {
        if (value.status) return value;
        const res = responseList.filter((value1) => value1.code == value.code);
        return res.length > 0 ? res : null;
      });
    }
  }
  return completeList.filter((value) => value.status);
};

export const setSelectsInactiveDataField = function (obj, field, completeList, filteredList) {
  if (obj && filteredList && completeList && obj[field] && !filteredList.some((item) => item.code == (Number.isNaN(obj[field]) ? obj[field] : Number(obj[field])))) {
    const elem = completeList.find((item) => item.code == (Number.isNaN(obj[field]) ? obj[field] : Number(obj[field])));
    filteredList.push(elem);
  }
};

export const setSelectsInactiveData = function (val, completeList, filteredList) {
  if (val && !filteredList.some((item) => item.code == (Number.isNaN(val) ? val : Number(val)))) {
    const elem = completeList.find((item) => item.code == (Number.isNaN(val) ? val : Number(val)));
    filteredList.push(elem);
  }
};

export const setSelectsInactiveDataName = function (val, completeList, filteredList) {
  if (val && !filteredList.some((item) => item.name == val)) {
    const elem = completeList.find((item) => item.name == val);
    filteredList.push(elem);
  }
};

export const getJson = function (str) {
  try {
    if (str && str != "" && str != "null" && str != "\"\"" && str != "n" && str != "{}" && str != "[]") {
      return JSON.parse(str);
    }
  } catch (e) {
    console.log(e);
    return null;
  }
  return null;
};

export const setJson = function (obj) {
  try {
    const str = JSON.stringify(obj);
    if (str && str != "" && str != "null" && str != "\"\"" && str != "n" && str != "{}" && str != "[]") {
      return str;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
  return null;
};

export const isJson = function (str) {
  if (!str) return false;
  if (Number.isNaN(str)) return false;
  if (!str.match(/^\[|^\{(?!\{)/)) return false;
  try {
    JSON.parse(str);
  } catch (e) {
    console.log(e);
    return false;
  }
  return true;
};

export const fixSe = function (se) {
  let str = "";
  if (se == undefined || se == null || se == "" || se.length <= 0) return "-";
  if (se instanceof Object) {
    if (!se) return "-";
    str = se.se;
    if (se.negocio == "OPTBLUE") str = se.seller;
  } else {
    str = se;
  }
  str = str.length == 10 ? str : str.replace(/^0+/, "");
  return str || "-";
};

export const makeid = function (length = 6) {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};

export const leadingZero = function (num, places) {
  return String(num).padStart(places, "0");
};



// WEBPACK FOOTER //
// ./src/helpers/form-common.js